export const LAUNCH_STATUS_LABELS = {
  planning: "Planificación",
  soft_launch: "Soft launch",
  active: "Activo",
  paused: "Pausado",
  completed: "Completado",
};

export const READINESS_STATUS_LABELS = {
  not_ready: "No listo",
  needs_review: "Revisar",
  ready_for_soft_launch: "Listo soft launch",
  ready_for_paid_launch: "Listo paid launch",
};

/** M18 — deferred buyer features hidden until implemented */
export const AUTOMAPA_SAVE_COMPARE_ENABLED = false;

export function trackBuyerLaunchEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[buyer-launch-event]", eventType, metadata);
  }
}
